module.exports = __webpack_public_path__ + "be78d72276668467555a8ac660ec652e.png";